import React from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../lib/store';
interface NowCompactProduct {
  id: number;
  name: string;
  brand?: string;
  price: number;
  originalPrice?: number;
  discount?: number;
  image: string;
  availabilityStatus?: 'available' | 'unavailable';
}
interface NowCompactProductCardProps {
  product: NowCompactProduct;
}
export function NowCompactProductCard({
  product
}: NowCompactProductCardProps) {
  const navigate = useNavigate();
  const addToCart = useStore(state => state.addToCart);
  const updateQuantity = useStore(state => state.updateQuantity);
  const cartItem = useStore(state => state.cart.find(item => item.id === product.id));
  const calculatedDiscount = product.discount ?? (product.originalPrice ? Math.round((product.originalPrice - product.price) / product.originalPrice * 100) : undefined);
  const addProduct = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    addToCart({
      id: product.id,
      name: product.name,
      price: product.price,
      image: product.image,
      brand: product.brand,
      availabilityStatus: product.availabilityStatus
    });
  };
  return <article role="button" tabIndex={0} onClick={() => navigate(`/product/${product.id}?from=now`)} onKeyDown={event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      navigate(`/product/${product.id}?from=now`);
    }
  }} className="group min-w-0 cursor-pointer rounded-lg bg-white p-1.5 focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-2" data-id="element-4359" data-mp="21wbx7ngwcks8">
      <div className="relative aspect-square overflow-hidden rounded-md bg-brand-soft" data-id="element-4360" data-mp="2gm9fxnw24ia1">
        <img src={product.image} alt={product.name} className="h-full w-full object-cover transition-transform duration-200 group-hover:scale-[1.03]" loading="lazy" data-id="element-4361" data-mp="1a7ik3ylsjnmv" />
        {calculatedDiscount && <span className="absolute left-1.5 top-1.5 rounded bg-[#ef3d68] px-1.5 py-0.5 text-[9px] font-bold text-white" data-id="element-4362" data-mp="16p1lj31t21w7">Save {calculatedDiscount}%</span>}
        {cartItem ? <span className="absolute bottom-1.5 right-1.5 flex h-8 items-center overflow-hidden rounded-md bg-white text-brand shadow-[0_1px_4px_rgba(52,52,52,0.16)]" data-id="element-4363" data-mp="xp65okxb1ipu">
            <button type="button" onClick={event => {
          event.stopPropagation();
          updateQuantity(product.id, cartItem.quantity - 1);
        }} className="flex h-8 w-8 items-center justify-center" aria-label={`Decrease ${product.name}`} data-id="element-4364" data-mp="11s2rslm1zwyj"><MinusIcon className="h-3.5 w-3.5" data-id="element-4365" data-mp="e0nig8vv0fds" /></button>
            <span className="min-w-5 text-center text-xs font-bold" data-id="element-4366" data-mp="e28hobt4cmhz">{cartItem.quantity}</span>
            <button type="button" onClick={event => {
          event.stopPropagation();
          updateQuantity(product.id, cartItem.quantity + 1);
        }} className="flex h-8 w-8 items-center justify-center" aria-label={`Increase ${product.name}`} data-id="element-4367" data-mp="j09y0oz5u7pr"><PlusIcon className="h-3.5 w-3.5" data-id="element-4368" data-mp="9y90rs3xflo3" /></button>
          </span> : <button type="button" onClick={addProduct} className="absolute bottom-1.5 right-1.5 flex h-8 w-8 items-center justify-center rounded-md bg-white text-brand shadow-[0_1px_4px_rgba(52,52,52,0.16)] transition-[background-color,transform] duration-150 active:scale-95" aria-label={`Add ${product.name} to cart`} data-id="element-4369" data-mp="3mj6di7agmja6">
            <PlusIcon className="h-4 w-4" strokeWidth={2.4} data-id="element-4370" data-mp="9b31lww8vfjg" />
          </button>}
      </div>
      <div className="px-0.5 pb-1 pt-2" data-id="element-4371" data-mp="4c08natjgzru">
        <h3 className="line-clamp-2 min-h-[32px] text-xs font-medium leading-4 text-gray-800" data-id="element-4372" data-mp="4axdurt3id6n">{product.name}</h3>
        <div className="mt-1 flex flex-wrap items-baseline gap-x-1" data-id="element-4373" data-mp="e2usy9n85pan">
          <span className="text-sm font-bold text-[#e6325c]" data-id="element-4374" data-mp="e3mojkgtnn0x">SAR {product.price.toFixed(2)}</span>
          {product.originalPrice && <span className="text-[10px] text-gray-400 line-through" data-id="element-4375" data-mp="s09qk1nmt3dp">{product.originalPrice.toFixed(2)}</span>}
        </div>
      </div>
    </article>;
}